class ScalperCountdown extends HTMLElement {
  connectedCallback() {
    this.deadline = new Date(this.dataset.deadline || '');
    if (Number.isNaN(this.deadline.getTime())) return;
    this.tick();
    this.timer = window.setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    window.clearInterval(this.timer);
  }

  tick() {
    const remaining = this.deadline.getTime() - Date.now();
    if (remaining <= 0) {
      this.textContent = this.dataset.expired || 'LIVE NOW';
      window.clearInterval(this.timer);
      return;
    }

    const days = Math.floor(remaining / 86400000);
    const hours = Math.floor((remaining % 86400000) / 3600000);
    const minutes = Math.floor((remaining % 3600000) / 60000);
    const seconds = Math.floor((remaining % 60000) / 1000);
    this.textContent = `${days}D ${String(hours).padStart(2, '0')}H ${String(minutes).padStart(2, '0')}M ${String(seconds).padStart(2, '0')}S`;
  }
}

if (!customElements.get('scalper-countdown')) {
  customElements.define('scalper-countdown', ScalperCountdown);
}

const scalperObserver = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        scalperObserver.unobserve(entry.target);
      }
    });
  },
  { threshold: 0.12 },
);

document.querySelectorAll('[data-scalper-reveal]').forEach((element) => scalperObserver.observe(element));

